import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CircularProgress, DialogContent } from '@mui/material';
import { CustomizedModal } from 'js/containers/Dialog/CustomizedModal';
import { Close } from '@mui/icons-material';

import { toast } from 'react-toastify';

import deleteUser from 'js/library/utils/API/deleteUser';

import './stylesDataConfirmation.css';

export function ModalConfirmationDeletedData({setStatusData, userInfo, toggleModal, open}) {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const { uId } = userInfo;

    async function handleDeleteUser() {

        setLoading(true);
       
        try {
            await deleteUser(uId);

            setStatusData();
            toggleModal();
            setLoading(false);
            toast.success(t('general.data_removed'));

        } catch (_){
            setLoading(false);
            toast.error(t('errors.try_again'));

        }
    }
   
    return(
        <CustomizedModal
            open={open}
            keepMounted
            onClose={loading ? null : toggleModal}
        >
            <DialogContent className='content-modal-delete-data'>
                <header className="header-modal-delete-data">
                    <strong> { t('general.confirming_data_deletion') }</strong>
                    <Close onClick={() => {if(!loading) toggleModal();}} />
                </header>

                <main className="main-modal-delete-data">
                    <p>
                        { t('general.confirming_data_deletion_warning') }
                    </p>
                </main>

                <div className='area-button-modal-delete-data'>
                    <button className="button-modal-delete-data" disabled={loading} onClick={toggleModal} type='button' > 
                        { t('general.cancel') }
                    </button>
                    <button disabled={loading} className="button-modal-delete-data" onClick={() => handleDeleteUser()} type='button' >
                        {loading ? <CircularProgress style={{ color: '#fff' }} size={20}/> : t('general.confirm')}
                    </button>
                </div>
            </DialogContent>
        </CustomizedModal>
    );
} 